import { ObservableQuery } from '@apollo/client';
import { Api } from '@ih/app/shared/apis/interfaces';

export class FindAllApisSuccess {
  public static readonly type = '[Project/Api/List] FindAllApisSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{ findAllApis: Api[] }>,
  ) {}
}
